import React from 'react';
import { useTranslation } from 'react-i18next';
import layoutStyles from '../../styles/layout.module.css';
import styles from './AboutUs.module.css';

const AboutUs: React.FC = () => {
  const { t } = useTranslation();

  const points = [
    { icon: '🇨🇴', key: 'presence' },
    { icon: '🇪🇸', key: 'expansion' },
    { icon: '👥', key: 'team' }
  ];

  return (
    <div className={styles.colorWrapper}>
      <section id="AboutUs" className={`${layoutStyles.container} ${styles.aboutUs}`}>
        <h2>{t('aboutUs.title')}</h2>
        <div className={styles.pointsGrid}>
          {points.map((point) => (
            <div key={point.key} className={styles.pointCard}>
              <span className={styles.icon}>{point.icon}</span>
              <h3>{t(`aboutUs.${point.key}.title`)}</h3>
              <p>{t(`aboutUs.${point.key}.description`)}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
